/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Rugendabari 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Gasave": ["Gakoma", "Gasharu", "Giturwa", "Nyagasozi", "Nyakibuye", "Nyamatete"],
  "Kanyana": ["Gasovu", "Kabuba", "Muheta", "Ntonde"],
  "Kibaga": ["Kiduha", "Mataba", "Njamena"],
  "Mpinga": ["Buganda", "Gisiza"],
  "Nsanga": ["Mpongo", "Ngando", "Nyundo", "Rugwiza", "Twabumbogo"]
};